export default __webpack_public_path__ + "static/media/004-chopsticks.c0634623.svg";